export const BodyFontFamily = 'Rubik, Roboto, system-ui, sans-serif';
export const HeadingFontFamily = 'Rubik, Roboto, Georgia, serif';

export const customColors = {
  background: '#F8F7F7',
  gray: {
    0: '#ffffff',
    50: '#f7f7f9',
    100: '#dcdde0',
    108: '#6c6c6c',
    200: '#bdbec2',
    250: '#85858B',
    270: '#595859',
    300: '#4c4c53',
    400: '#1d1e23',
    500: '#000000',
  },
  blue: {
    50: '#eff5ff',
    100: '#d0e0ff',
    200: '#66a2ff',
    300: '#1563ff',
    400: '#0d44cc',
    500: '#08368b',
  },
  skyBlue: {
    50: '#EBF8FF',
    100: '#BFE8FE',
    200: '#6BCEFF',
    300: '#00ACFF',
    400: '#0074BA',
    500: '#005283',
  },
  purple: {
    50: '#F5F3FF',
    100: '#DDD6FA',
    200: '#A28CE8',
    300: '#623CE4',
    400: '#3C2AA8',
    500: '#2A1C73',
  },
  green: {
    50: '#eefcf7',
    100: '#caefe1',
    200: '#87d5b6',
    300: '#54b884',
    400: '#337656',
    500: '#1d4b3b',
  },
  red: {
    50: '#f8dede',
    100: '#f5cecd',
    200: '#efaead',
    300: '#e98683',
    400: '#e4615c',
    500: '#cc575b',
    600: '#b74e51',
    700: '#ad4a4d',
    800: '#a34548',
  },
  yellow: {
    50: '#fdf2d2',
    100: '#fcebbc',
    200: '#fade91',
    300: '#f8cd61',
    400: '#f5bd43',
    500: '#dc9d38',
  },
  indigo: {
    50: '#948FF3',
    100: '#8882F1',
    200: '#7C76F0',
    300: '#7069EE',
    400: '#645DED',
    500: '#5850ec',
    600: '#453CE9',
    700: '#3128E7',
    800: '#2319E0',
    900: '#2017CB',
  },
  primaryShades: {
    50: '#9592ef',
    100: '#857fea',
    200: '#776be6',
    300: '#6956e1',
    500: '#5d3edb',
  },
};

// Values referenced by the current light and dark palettes that come from
// Chakra's default v2 theme rather than the application's custom palettes.
export const defaultColors = {
  red: {
    500: '#E53E3E',
    600: '#C53030',
  },
  blue: {
    300: '#63B3ED',
  },
  green: {
    300: '#68D391',
  },
  orange: {
    500: '#DD6B20',
  },
  yellow: {
    500: '#D69E2E',
  },
  whiteAlpha: {
    400: 'rgba(255, 255, 255, 0.24)',
  },
};

export const fixedColors = {
  aws: '#FF9900',
  azure: '#007FFF',
  gcp: '#34a853',
  vmware: '#53565a',
  iconColor: '#6563ff',
  gettingStartedItemBg: '#ffffff40',
};

export const fontWeights = {
  xs: 300,
  sm: 400,
  md: 500,
  lg: 600,
  bold: 700,
};

export const sizes = {
  58: '14.5rem',
  '7xl': '80rem',
  '8xl': '90rem',
  '9xl': '100rem',
  primaryNavBarHeight: '50px',
  secondaryNavBarHeight: '36px',
  breadcrumbHeight: '60px',
  totalHeaderHeight: '80px',
  layoutLeftWidth: '254px',
  formWidth: '600px',
  bodyPadding: 4,
  interCardSpacing: 4,
  dashboardCardSpacing: 14,
  minScreenWidth: '1024px',
  minUIWidth: '110rem',
  tableCell: '16px',
};

export const fontSizes = {
  navBarHeader: '15px',
  secondaryNavBarHeader: '16px',
  '2xs': '10px',
  tableCell: '16px',
  tableHederCell: '15px',
  dashboardRowHeader: '18px',
  dashboardRowSubHeader: '14px',
};

export const space = {
  layoutLeftWidth: '254px',
  thLeftPaddingWithIcon: '3rem',
  headerContentSpacing: '1.25rem',
};

export const radii = {
  fieldBorderRadius: '6px',
  cardBorderRadius: '8px',
};

const token = value => ({ value });

const tokenMap = values =>
  Object.fromEntries(
    Object.entries(values).map(([key, value]) => [key, token(value)]),
  );

const colorTokenMap = values =>
  Object.fromEntries(
    Object.entries(values).map(([key, value]) => [
      key,
      typeof value === 'object' ? tokenMap(value) : token(value),
    ]),
  );

// Chakra v3 token shape. Keep this separate from the v2 adapter so the
// component migration can switch the provider without changing token values.
export const chakraV3Tokens = {
  colors: {
    ...colorTokenMap(customColors),
    ...colorTokenMap(fixedColors),
  },
  fonts: tokenMap({ body: BodyFontFamily, heading: HeadingFontFamily }),
  fontWeights: tokenMap(fontWeights),
  sizes: tokenMap(sizes),
  fontSizes: tokenMap(fontSizes),
  spacing: tokenMap(space),
  radii: tokenMap(radii),
};
